import React, { useRef, useState } from "react";
import { useSelector } from "react-redux";
import BackdropPopup from "../../UI/BackdropPopup";
import classes from './SelectStudyGroupPopup.module.css';
import selectArrowIcon from '../../../assests/ui/select-arrow.png';
import closeIcon from '../../../assests/ui/x.png';
import { onKeyDown } from "../../../service";

const SelectStudyGroupPopup = ({ localStudyGroupId, setLocalStudyGroupId, setShowSelectStudyGroup, handleCopyProject }) => {

    const [showSelect, setShowSelect] = useState(false);

    const selectRef = useRef(null);

    const { texts, direction } = useSelector(state => state.translate);
    const { curriculums } = useSelector(state => state.curriculums);

    const handleSelect = (x) => {
        setLocalStudyGroupId(x)
        setShowSelect(false);
    }

    const handleChangeSelect = e => {
        e.stopPropagation();
        setShowSelect(true);
    }

    return (
        <BackdropPopup myHeight='287px'>
            <div className={`${classes[direction]} ${classes.Popup}`}>
                <div className={classes.Header}>
                    <img src={closeIcon} className={classes.CloseIcon} onClick={() => setShowSelectStudyGroup(null)} />
                    <div>{texts.copyToMyProjects}</div>
                </div>
                <div className={classes.PopupContainer}>
                    <div>{texts.duplicateProjectInStudyGroup}</div>
                    <div className={classes.SelectContainer}>
                        <div className={classes.SelectWrapper}>
                            <div className={classes.SelectSelected} onClick={handleChangeSelect} tabIndex="0" role="button" onKeyDown={e => onKeyDown(e, handleChangeSelect)}>
                                <div>{curriculums?.find(c => c.id === localStudyGroupId)?.name || texts.chooseStudyGroup}</div>
                                <img src={selectArrowIcon} alt="SelectArrow" className={showSelect ? classes.SelectArrowIconOpen : classes.SelectArrowIconClose} />
                            </div>
                            {showSelect && <div ref={selectRef} className={classes.SelectDropDown}>
                                {curriculums?.map(c => <div key={c.id} className={classes.Option} onClick={() => handleSelect(c.id)} tabIndex="0" role="button" onKeyDown={e => onKeyDown(e, () => handleSelect(c.id))}>{c.name}</div>)}
                            </div>}
                        </div>
                    </div>
                </div>
                <div className={classes.BtnsContainer}>
                    <button className={`${classes.Btn} ${classes.BtnCancel}`} onClick={() => setShowSelectStudyGroup(null)}>{texts.cancel}</button>
                    <button className={`${classes.Btn} ${classes.BtnOk}`} onClick={handleCopyProject}>{texts.add}</button>
                </div>
            </div>
        </BackdropPopup>
    )
}

export default SelectStudyGroupPopup;